/**
 * Navigation map.
 *
 * Every entry names the permission that gates it, and the permission strings are
 * the same ones the API enforces (served from /meta/permissions). A link is
 * therefore never shown for something that would come back 403 — the sidebar and
 * the server agree by construction rather than by being kept in sync by hand.
 */
export const NAV_GROUPS = [
  {
    group: 'Overview',
    items: [
      { to: '/', end: true, id: 'dashboard', label: 'Dashboard', icon: 'grid' },
      { to: '/me', id: 'me', label: 'My Space', icon: 'user' },
    ],
  },
  {
    group: 'People',
    items: [
      { to: '/directory', id: 'directory', label: 'Directory', icon: 'users', permission: 'directory.read' },
      { to: '/org', id: 'org', label: 'Org Chart', icon: 'sitemap', permission: 'directory.read' },
      { to: '/onboarding', id: 'onboarding', label: 'Onboarding', icon: 'userPlus', permission: 'onboarding.manage', badge: 'onboarding', badgeSoft: true },
      { to: '/offboarding', id: 'offboarding', label: 'Offboarding', icon: 'userMinus', permission: 'offboarding.manage' },
      { to: '/documents', id: 'documents', label: 'Documents', icon: 'folder', permission: 'documents.read.self' },
    ],
  },
  {
    group: 'Time',
    items: [
      { to: '/attendance', id: 'attendance', label: 'Attendance', icon: 'clock', permission: 'attendance.read.self' },
      { to: '/biometric', id: 'biometric', label: 'Biometric Devices', icon: 'fingerprint', permission: 'device.read' },
      { to: '/leave', id: 'leave', label: 'Leave', icon: 'plane', permission: 'leave.request', badge: 'leave' },
      { to: '/holidays', id: 'holidays', label: 'Holidays', icon: 'calendar' },
    ],
  },
  {
    group: 'Work',
    items: [
      { to: '/performance', id: 'performance', label: 'Performance', icon: 'target', permission: 'performance.read.self' },
      { to: '/payroll', id: 'payroll', label: 'Payroll', icon: 'wallet', permission: 'payroll.read.self' },
      { to: '/announcements', id: 'announcements', label: 'Announcements', icon: 'megaphone', permission: 'announcement.read' },
      { to: '/helpdesk', id: 'helpdesk', label: 'Help Desk', icon: 'ticket', permission: 'ticket.create', badge: 'helpdesk' },
    ],
  },
  {
    group: 'Intelligence',
    items: [
      { to: '/insights', id: 'insights', label: 'AI Insights', icon: 'sparkles', permission: 'insights.read' },
      { to: '/reports', id: 'reports', label: 'Reports', icon: 'chart', permission: 'reports.read' },
    ],
  },
  {
    group: 'Governance',
    items: [
      { to: '/audit', id: 'audit', label: 'Audit Trail', icon: 'history', permission: 'audit.read' },
      { to: '/security', id: 'security', label: 'Security & Data', icon: 'shield', permission: 'security.manage' },
      { to: '/settings', id: 'settings', label: 'Settings', icon: 'settings', permission: 'settings.manage' },
    ],
  },
];

export const ALL_NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

export const DEMO_ACCOUNTS = [
  { email: 'hr@sevenmentor.com', role: 'HR', label: 'HR', note: 'Full people operations' },
  { email: 'manager@sevenmentor.com', role: 'MANAGER', label: 'Manager', note: 'Their reporting tree and approvals' },
  { email: 'employee@sevenmentor.com', role: 'EMPLOYEE', label: 'Employee', note: 'Self-service only' },
  { email: 'admin@sevenmentor.com', role: 'ADMIN', label: 'Administrator', note: 'Devices, roles and security' },
  { email: 'management@sevenmentor.com', role: 'MANAGEMENT', label: 'Management', note: 'Company-wide numbers, read only' },
];

export const ROLE_LABEL = {
  EMPLOYEE: 'Employee', MANAGER: 'Manager', HR: 'HR',
  MANAGEMENT: 'Management', ATTENDANCE_VIEWER: 'Attendance viewer', ADMIN: 'Administrator',
};
